module.exports = __webpack_public_path__ + "static/swetha_avatar-556682702d0a6efce1f9aaa464dceb96.png";